import { render } from "./Ellipsis.vue?vue&type=template&id=3d5c2701&scoped=true&ts=true"
import script from "./Ellipsis.vue?vue&type=script&lang=ts"
export * from "./Ellipsis.vue?vue&type=script&lang=ts"

import "./Ellipsis.vue?vue&type=style&index=0&id=3d5c2701&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5c2701"]])

export default __exports__